import classNames from 'classnames'
import React from 'react'

export default function ParkingCard({
    data,
    component,
    titleComponent,
    actions,
    fullHeight
}) {

    const Component = component || "div"
    const TitleComponent = titleComponent || "div"

    const ContainerClasses = classNames({
        'group block w-full': true,
        'h-full': fullHeight,
        'cursor-pointer': data.link,
    })

    const CardClasses = classNames({
        'bg-white w-full rounded-xl shadow-md box-border overflow-hidden': true,
        'h-full flex flex-col': fullHeight,
        'hover:shadow-lg transition-all': data.link,
    })

    const BodyClasses = classNames({
        'px-4 py-3 box-border': true,
        'flex-1': fullHeight
    })

    return (
        <Component className={ContainerClasses} href={data.link} to={data.link}>
            <div className={CardClasses}>
                {data.image &&
                    <div className='w-full aspect-video bg-cover bg-center' style={{backgroundImage: `url(${data.image})`}}></div>
                }

                <div className={BodyClasses}>
                    {data.title &&
                        <TitleComponent className='text-md font-medium leading-tight'>{data.title}</TitleComponent>
                    }
                    {data.subtitle &&
                        <p className='text-sm pt-px text-gray'>{data.subtitle}</p>
                    }
                    {data.description &&
                        <p className='text-sm pt-1 text-primary'>{data.description}</p>
                    }
                </div>

                {actions &&
                    <div className='flex border-t border-line'>
                        {actions.map((action, index) => {

                            const ActionComponent = action.component || "div"
                            
                            const ActionClasses = classNames({
                                "flex-1 text-center p-3 box-border": true,
                                "bg-primary text-white hover:bg-primaryhover": action.primary,
                            })

                            return (
                                <ActionComponent
                                    href={action.link}
                                    to={action.link}
                                    onClick={action.onClick}
                                    className={ActionClasses}
                                    key={`action-${index}`}
                                >{action.text}</ActionComponent>
                            )
                        })}
                    </div>
                }
            </div>
        </Component>
    )
}
